import { SnapshotDataMap } from "csi/state/3D/snapshotsStore";
import { useStore } from "csi/state/hooks";
import TurntableImageBox from "designSystem/components/box/TurntableImageBox";
import CsiImage from "designSystem/components/image/CsiImage";
import { Box, Checkbox, Chip } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React, { useRef } from "react";
import { ReactZoomPanPinchRef } from "react-zoom-pan-pinch";
import css from "./SnapshotImage.module.css";

export interface SnapshotImageProps {
	data: SnapshotDataMap;
	index: number;
}

export const SnapshotImage = observer((props: SnapshotImageProps) => {
	const { threeDStore } = useStore();
	const { setSelectedSnapshots, hideTags } = threeDStore.snapshotsStore;
	const { index, data } = props;
	const { img, isSelected, configuration, isTurntable } = props.data;

	const turntableImageBoxRef = useRef<ReactZoomPanPinchRef>(null);

	return (
		<Box 
			border={STANDARD_BORDER_STYLE}
			borderRadius={1}
			onClick={(e) => {
				setSelectedSnapshots(!isSelected, [data]);
			}}
			position="relative"
			sx={{
				"&:hover": {
					cursor: "pointer",
				},
			}}
		>
			{
				isTurntable ? (
					<TurntableImageBox
						aspectRatio={1}
						imageList={props.data.imgGallerySrc}
						panning={{
							disabled: true,
						}}
						ref={turntableImageBoxRef}
					/>
				)
					: (
						<CsiImage
							aspectRatio={1}
							src={img}
						/>
					)
			}
			<Checkbox 
				checked={isSelected} 
				className={css.snapshotImage}
				onChange={(e, val)=> setSelectedSnapshots(val, [data])}
			/>
			{
				!hideTags && configuration?.cameraPosition && (
					<Chip
						className={css.snapshotTag}
						label={configuration.cameraPosition.name}
					/>
				)
			}
		</Box>
	);
});